import React from 'react';
import {Background, Children} from './AppBackground-styles';

type Props = {children: React.ReactNode};

const AppBackground = ({children}: Props) => {
  return (
    <Background>
      <Children>{children}</Children>
    </Background>
  );
};

export default AppBackground;
